import api1 from './api1'
import api2 from './api2'
import api3 from './api3'
import api4 from './api4'
import common from './common'
let allApi = Object.assign(api1, api2, api3, api4, common)
export default allApi
